import { Component } from '@angular/core';
import { Municipio } from '../../../../types/Municipio.type';
import { MunicipiosService } from './municipios.service';
import { ToastService } from '../../../../services/toast.service';

@Component({
  selector: 'app-municipios',
  templateUrl: './municipios.component.html',
  styleUrl: './municipios.component.css'
})
export class MunicipiosComponent {

  municipios: Municipio[] = []

  loading: boolean = false;
  loadingSincronizar: boolean = false;

  constructor(private municipiosService: MunicipiosService, private toastService: ToastService){
    this.getAll()
  }

  getAll(){
    this.loading = true;
    this.municipiosService.getAll().subscribe({
      next: (data: Municipio[]) => { this.municipios = data; this.loading = false },
      error: (err: any) => { console.error(err); this.toastService.erro('Erro', 'Falha ao carregar municípios: ' + (err?.error ?? err)); this.loading = false }
    })
  }

  exportar(){
    this.loadingSincronizar = true;
    this.municipiosService.exportar().subscribe({
      next: (value: Blob) => {
        const url = window.URL.createObjectURL(value);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'municipios.xlsx';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      },
      error: (error: any) => {
        this.toastService.erro('Exportar', 'Erro ao exportar: ' + (error?.error ?? error));
        this.loadingSincronizar = false;
      },
      complete: () => { this.loadingSincronizar = false }
    })
  }
}
